import React, { CSSProperties } from 'react';
import { extractInitials, pickBackgroundColorOrIcon } from '../helperFunctions';
import './DefaultImageVariants.scss';

interface IDefaultImageProps {
    organizerName: string;
    organizerId: string;
    variantType: string;
}
interface CustomCSSProperties extends CSSProperties {
    '--bg-color'?: string;
}

const DefaultImageVariants: React.FunctionComponent<IDefaultImageProps> = ({
    organizerName,
    organizerId,
    variantType,
}) => {
    const initialLetter = extractInitials(organizerName);

    const [backgroundColor, selectedIcon] =
        pickBackgroundColorOrIcon(organizerId);

    const componentStyle: CustomCSSProperties = {
        '--bg-color': String(backgroundColor),
    };

    return (
        <>
            {variantType === 'variant-a' && (
                <div
                    data-testid="variant-a-image"
                    className="simplified-organiser-info_default-image-circle"
                    style={componentStyle}
                >
                    <span className="simplified-organiser-info_default-image-text">
                        {initialLetter}
                    </span>
                </div>
            )}
            {variantType === 'variant-b' && selectedIcon && (
                <div
                    data-testid="variant-b-image"
                    className="simplified-organiser-info_default-image_variantB"
                >
                    {selectedIcon}
                </div>
            )}
        </>
    );
};

export default DefaultImageVariants;
